import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";
import { IImportablePatient } from "@/Common/Models/Patient/IPatient";
import { Person } from "@/Common/Models/Person/Person";
import { PatientImportValidationResult } from "./PatientImportValidationResult";

interface IPatientImportValidationPopupProps {
    patientToImport: IImportablePatient;
    selectedPerson: Person;
    failedPatientImportValidationResults: PatientImportValidationResult[];
    onLink: (patient: Person) => void;
    onClose: () => void;
}

class PatientImportValidationPopup extends BaseReactComponent<IPatientImportValidationPopupProps> {
    public render(): JSX.Element {
        return (
            <Modal
                showOverlay
                showX
                disableOverlayClose
                title={cacheStore.GetString("WarningLabel")}
                width={650}
                onClose={() => this.props.onClose && this.props.onClose()}
                footer={this.renderFooter()}
            >
                <div className="pa-selected-items-list" style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {this.props.failedPatientImportValidationResults.map((result, idx) =>
                        <div key={idx + result.validationMessageLabel}>{cacheStore.GetString(result.validationMessageLabel)}</div>
                    )}
                </div>
            </Modal>
        );
    }

    private renderFooter(): JSX.Element {
        return (
            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                <div style={{ "marginLeft": "5px" }}>
                    <button className="btn btn-default" onClick={() => this.props.onClose && this.props.onClose()}>
                        {cacheStore.GetString("CancelLabel")}
                    </button>
                </div>
                <div style={{ "marginLeft": "5px" }}>
                    <button
                        className="btn btn-primary"
                        onClick={() => this.props.onLink && this.props.onLink(this.props.selectedPerson)}
                    >
                        {cacheStore.GetString("LinkLabel")}
                    </button>
                </div>
            </div>
        );
    }
}

export { PatientImportValidationPopup };
